import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import RefreshButton from '../Button/RefreshButton/RefreshButton';
import styles from './error.module.css';

export interface ErrorProps extends WithTestId {
  text: string;
  code?: {
    value: number;
    label: string;
  };
}

const Error = ({ text, code, dataTestIdPrefix }: ErrorProps): JSX.Element => {
  return (
    <div
      className={styles.error}
      data-testid={toKebabCase(dataTestIdPrefix, 'error')}
    >
      <p className={styles.errorText}>
        {text}
        {code ? `. ${code.label}: ${code.value}` : ''}
      </p>
      <RefreshButton
        dataTestIdPrefix={toKebabCase(dataTestIdPrefix, 'error')}
      />
    </div>
  );
};

export default Error;
